import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { firestore } from '../../../firebase';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import StateContext from '../../../StateContext';
import ImageGrid from '../Media/ImageGrid';

import './QuillEditor.css'
import CategoriesSelector from './CategoriesSelector';

function EditPost() {

    const {id} = useParams();

    const appState = useContext(StateContext)

    const [post, setPost] = useState()
    const [title, setTitle] = useState("")
    const [date, setDate] = useState("")
    const [authorName, setAuthorName] = useState("")
    const [content, setContent] = useState("");
    const [image, setImage] = useState("")

    const [categories, setCategories] = useState([])


    const [showImage, setShowImage] = useState(false);

    const [message, setMessage] = useState("")


    useEffect(() => {

        try {
            const postRef = firestore.collection("football-blogs").doc(id);
            postRef.onSnapshot(doc => {
                const post = {id: doc.id, ...doc.data()}
                
                setPost(post);
                setTitle(post.title)

                const dateISO = new Date(post.date_iso);
                const dateFormatted = formatDate(dateISO)

                setDate(dateFormatted);
                setContent(post.content)
                setImage(post.featured_image_post)
                setAuthorName(post.author_name)
            })
        } catch (error) {
            
        }

    }, [id])

    async function editPostHandler(e) {
        e.preventDefault();

        try {
            const postRef = firestore.collection("football-blogs").doc(id);

            let dateISO;
            if (date) {
                dateISO = new Date(date).toISOString();
            }
            

            const data = {
                title,
                content,
                date_iso: dateISO,
                featured_image_post: image,
                author_name: authorName,
                updated_at: new Date().toISOString(),
                categories: categories
            }
            console.log(data)
            postRef.update(data)
            setMessage("Oppdatert!")
        } catch (error) {
            setMessage("Kunne ikke oppdatere")
        }

    }

    function toggleImageGrid() {
        if (showImage) {
            setShowImage(false);
        } else {
            setShowImage(true)
        }

    }

    function formatDate(date) {
        
        const datePost = new Date(date);

        let month, day
        console.log(datePost)
        month = datePost.getMonth()+1;
        day = datePost.getDate();

        if (month < 10) {
            month = `0${month}`;
        }
        if (day < 10) {
            day = `0${day}`;
        }

        const dateFormatted = datePost.getFullYear() + "-" + month + "-" + day;

        return dateFormatted;

    }

    if (!appState.loggedIn) return <p>Logg inn for å redigere</p>

    return (
        <div className="container">

            <form onSubmit={editPostHandler}>

                <div className="row">

                    <div className="col-lg-8">
                        <label>Tittel</label>
                        <input className="form-control mb-3" value={title} onChange={e => setTitle(e.target.value)} />

                        <label>Innhold</label>
                        <ReactQuill theme="snow" value={content} onChange={setContent} />


                    </div>

                    <div className="col-lg-4">
                        <label>Dato</label>
                        <input type="date" className="form-control" value={date} onChange={e => setDate(e.target.value)} />
                        <br />
                        <label>Velg kategorier</label>
                        <CategoriesSelector categories={categories} setCategories={setCategories} />
                        <div className="btn btn-success" style={{cursor: "pointer"}} onClick={toggleImageGrid}>Velg nytt fremhevet bilde</div>
                        {showImage && <ImageGrid setSelectedImg={setImage} setShowImage={setShowImage} />}

                        <div className="my-4">
                            <img src={image} alt={title} className="img-fluid" />
                        </div>

                        {message && <div className="alert alert-success" > {message} </div>}
                        <button className="btn btn-primary">Lagre</button>
                    </div>

                </div>

            </form>

        </div>
    )
}
export default EditPost